import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const Search = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: -2.5rem;
  position: relative;
  width: 100%;
`;

export const Main = styled.div`
 display: flex;
 flex-direction:column;
 align-items:flex-start;
 justify-content:flex-start;
 flex-wrap:nowrap;
 width: 100%;

 font: var(--body);

 @media (max-width: 600px) {}
 @media (max-width: 768px) {}
 @media (max-width: 992px) {}
 @media (max-width: 1200px) {}
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  width: 100%;
  padding: 2rem 0 0 0;
  font: var(--title);
`;


export const Description = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: justify;
  flex-wrap: nowrap;
  width: 83%;
  line-height: 3rem;
  font: var(--body);
`;

export const IconEdit = styled.img`
  cursor: pointer;
  width: calc(var(--size) * 4);
  margin: 0 0 0 2rem;
`;

export const Feed = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 2rem;
  background-color: var(--gray);
  width: 100%;
  padding: 2rem;
  border-radius: 1rem;
  margin-bottom: 3rem;
`;

export const DivEditMsg = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  width: 83%;
  font: var(--title);

  :hover {
    font-size: calc(var(--size) * 1.9);
    transition: font-size 0.3s;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const LinkDoc = styled.a`
  display: flex;
  justify-content: start;
  width: 100% ;
  transition: transform 0.3s;
  cursor: pointer;
  font-size: calc(var(--size) * 1.5);
  /* font: var(--body); */
  outline: none;
  text-decoration: none;
  color: var(--primary);
  font-weight: bold;
  padding-left: 1rem;

  :hover {
    /* transform: scale(0.9); */
    color: var(--darkBlue);
    font-weight: bold;
    font-size: calc(var(--size) * 1.6);
  }
`

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  text-align: justify;
  font: var(--body);
`;

export const DivDocs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  text-align: justify;
  border: 0.1rem solid;
  border-radius: 1rem;
  padding: 2rem;
  background-color: var(--softGray);
  width: 100%;
`;

export const DivViewDocs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  text-align: justify;
`;

export const Icon = styled.img`
  display: flex;
  align-items:center;
  justify-content:center;
  flex-wrap:nowrap;
  width: 3.5rem;
  margin: 1rem 2.5rem 0 1rem; 
`;